import React from 'react';
import ReactDOM from 'react-dom/client'; 
import './index.css';
import App from './App.tsx';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import { SessionContextProvider } from './components/payments/common/UserContext.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SessionContextProvider>
    <BrowserRouter basename="/boardepayments">
      <App />
    </BrowserRouter>
    </SessionContextProvider>
  </React.StrictMode>
);

